import React, { useState, useEffect } from "react";
import { Row, Col, Accordion, Card, Form } from "react-bootstrap";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
	faChevronUp,
	faChevronDown,
	faXmark,
} from "@fortawesome/free-solid-svg-icons";

import { REACT_APP_SERVER_WAREHOUSE_SERVER_BASE_URL } from "config";
import CompatibleProductsList from "pages/ProductCompatibility/components/Compatibility/components/CompatibleProductsList";

const Compatibility = ({
	baseProductId,
	compatibilityId,
	onDeletedCompatibility,
}) => {
	const [compatibility, setCompatibility] = useState({});
	const [isAccordionOpen, setIsAccordionOpen] = useState(false);
	const [canMixPartCodes, setCanMixPartCodes] = useState(false);
	const [maxCountUnit, setMaxCountUnit] = useState(0);

	const getCompatibility = async () => {
		try {
			const response = await axios.get(
				`${REACT_APP_SERVER_WAREHOUSE_SERVER_BASE_URL}/api/admin/base-products/${baseProductId}/compatibilities/${compatibilityId}`
			);
			if (response.status === 200) {
				const compatibility = response.data.compatibility;
				setCompatibility(compatibility);
				setCanMixPartCodes(compatibility.compatibility.canMixPartCodes);
				setMaxCountUnit(compatibility?.compatibility?.maxCountUnit);
			}
		} catch (error) {
			console.log("error: ", error);
		}
	};

	useEffect(() => {
		getCompatibility(); // eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const updateCompatibility = async (update) => {
		try {
			const response = await axios.put(
				`${REACT_APP_SERVER_WAREHOUSE_SERVER_BASE_URL}/api/admin/base-products/${baseProductId}/compatibilities/${compatibilityId}`,
				update
			);
			if (response.status === 200) {
				getCompatibility();
			}
		} catch (error) {
			console.log("error: ", error);
		}
	};

	const deleteCompatibility = async () => {
		try {
			const response = await axios.delete(
				`${REACT_APP_SERVER_WAREHOUSE_SERVER_BASE_URL}/api/admin/base-products/${baseProductId}/compatibilities/${compatibilityId}`
			);
			if (response.status === 200) {
				if (onDeletedCompatibility) {
					onDeletedCompatibility();
				}
			}
		} catch (error) {
			console.log("error: ", error);
		}
	};

	return (
		<div style={{ padding: "10px 0px" }}>
			<Accordion defaultActiveKey="0">
				<Card>
					<Accordion.Toggle
						as={Card.Header}
						eventKey="1"
						onClick={() => setIsAccordionOpen(!isAccordionOpen)}>
						<Row>
							<Col>
								{isAccordionOpen ? (
									<FontAwesomeIcon icon={faChevronUp} />
								) : (
									<FontAwesomeIcon icon={faChevronDown} />
								)}{" "}
								<span
									style={{
										marginLeft: 10,
									}}>
									{compatibility?.category?.name} (
									{compatibility?.compatibility
										?.compatibleProductsBCIds?.length ?? 0}
									)
								</span>
							</Col>
							<Col xs="auto">
								<FontAwesomeIcon
									icon={faXmark}
									size="2xl"
									onClick={(e) => {
										e.stopPropagation();
										if (
											compatibility?.compatibility
												?.compatibleProductsBCIds
												?.length === 0
										) {
											if (
												window.confirm(
													"Are you sure you want to delete this Compatibility?"
												)
											) {
												deleteCompatibility();
											}
										} else {
											alert(
												"Please ensure the Compatibility is empty before deleting."
											);
										}
									}}
								/>
							</Col>
						</Row>
					</Accordion.Toggle>
					<Accordion.Collapse eventKey="1">
						<Card.Body>
							<div>
								<Row
									style={{
										alignItems: "baseline",
									}}>
									<Col xs={{ span: 4 }}>
										<Form.Group controlId="canMixPartCodes">
											<Form.Check
												style={{
													color: compatibility
														?.compatibility
														?.canMixPartCodes
														? "blue"
														: "",
												}}
												type="checkbox"
												label="Can Mix Part Codes"
												checked={canMixPartCodes}
												onChange={() => {
													setCanMixPartCodes(
														!compatibility
															?.compatibility
															?.canMixPartCodes
													);
													updateCompatibility({
														canMixPartCodes:
															!compatibility
																?.compatibility
																?.canMixPartCodes,
													});
												}}
											/>
										</Form.Group>
									</Col>
									<Col xs={{ span: 8 }}>
										<Form.Group
											as={Row}
											controlId="maxCountUnit"
											style={{
												alignItems: "baseline",
											}}>
											<Form.Label xs="auto">
												Max Unit Count:
											</Form.Label>
											<Col xs="auto">
												<Form.Control
													type="number"
													style={{ width: "50%" }}
													min="0"
													value={maxCountUnit}
													onChange={(e) => {
														setMaxCountUnit(
															e.target.value
														);
														updateCompatibility({
															maxCountUnit:
																e.target.value,
														});
													}}
												/>
											</Col>
										</Form.Group>
									</Col>
								</Row>
								<Row>
									<Col>
										<h4>Parts</h4>
									</Col>
									<Col xs="auto">
										<button
											style={{
												border: "none",
												background: "none",
											}}
											onClick={() => {
												if (
													window.confirm(
														"Are you sure you want to remove all parts from this compatibility? IMPORTANT: This is irreversible!"
													)
												) {
													updateCompatibility({
														compatibleProductsBCIds:
															[],
													});
												}
											}}>
											<FontAwesomeIcon
												icon={faXmark}
												size="lg"
											/>{" "}
											Remove All
										</button>
									</Col>
								</Row>
								{compatibility?.compatibility
									?.compatibleProductsBCIds && (
									<CompatibleProductsList
										compatibleProductsBCIds={
											compatibility.compatibility
												.compatibleProductsBCIds
										}
										categoryBcId={
											compatibility?.category?.id
										}
										baseProductId={baseProductId}
										compatibilityId={compatibilityId}
										updateCompatibility={
											updateCompatibility
										}
										onAddedCompatibility={getCompatibility}
										compatibleProductsBCIdsPositionsFromServer={
											compatibility.compatibility
												?.compatibleProductsBCIdsPositions
										}
									/>
								)}
							</div>
						</Card.Body>
					</Accordion.Collapse>
				</Card>
			</Accordion>
		</div>
	);
};

export default Compatibility;
